module.exports = ".widget-16 p{word-wrap:normal}.widget-16-chart{height:100px}\n"